import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const MessageAuthorAndTimeStyled = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  text-transform: uppercase;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;
